import { render } from "./rep120.vue?vue&type=template&id=2f229060"
import script from "./rep120.vue?vue&type=script&lang=js"
export * from "./rep120.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__